import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
function SelectSignupType() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
    return (
    <Container fluid className='m-0 p-0' >
       <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
                <Container>


                    <h2 class="text-white pt-3">Sign Up</h2>



                </Container>

            </div>
   
        <Container className='p-4'>

       
              <Row >
      
      <Col sm={6}  style={{padding:'2%', margin:'4% auto', border:'1px solid #2489B4'} } >
      <p>Let’s get started</p>
      <p style={{fontSize:'16px'}}>Select Registration Type</p>
      <form>
        <label className={`radio-button ${selectedOption === 'Option 1' ? 'selected' : ''}`}>
          <input
            type="radio"
            name="option"
            value="Option 1"
            checked={selectedOption === 'Option 1'}
            onChange={handleChange} style={{display:'none'}}
          />
          <span style={{fontSize:'26px'}}> <i class="bi bi-person"></i> Jobseeker</span>
        </label>

        <label className={`radio-button ${selectedOption === 'Option 2' ? 'selected' : ''}`}>
          <input
            type="radio"
            name="option"
            value="Option 2"
            checked={selectedOption === 'Option 2'}
            onChange={handleChange} style={{display:'none'}}
          />
          <span style={{fontSize:'26px'}}><i class="bi bi-briefcase" ></i> Employeer</span>
        </label>
        <div className='text-center ml-2 mr-2 mt-4'>
      <Button  className='rounded-button'> Next <i class="bi bi-arrow-right"></i></Button>
      </div>
      </form>
    
      </Col>
      </Row>
      </Container>

    

     
    </Container>

  );


}

export default SelectSignupType